export default "__VITE_ASSET__4aa801c6__"